import styled from 'styled-components';

export const FormContainer = styled.div`
  padding: 10px 5px 0;
  max-width: 520px;
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
`;

export const Description = styled.p`
  font-size: 13px;
  color: #666;
  margin-bottom: 16px;
  line-height: 1.45;
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #2f2f2f;
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 24px;
`;

export const Button = styled.button`
  padding: 10px 24px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled(Button)`
  background-color: #1a1a1a;
  color: white;

  &:hover:not(:disabled) {
    background-color: #2f2f2f;
  }
`;

export const SubmitButton = styled(Button)`
  background-color: #595959;
  color: white;

  &:hover:not(:disabled) {
    background-color: #404040;
  }
`;

export const ErrorMessage = styled.div`
  background-color: #dee2e6;
  border: 1px solid #8a8a8a;
  color: #1a1a1a;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 14px;
`;

export const LoadingMessage = styled.div`
  text-align: center;
  padding: 20px;
  color: #666;
  font-size: 14px;
`;
